import { useEffect } from 'react';
import { batch } from 'react-redux';
import { useAppDispatch } from '../../../redux/hooks';
import { dashboardInstanceReset } from '../../../redux/slices/dashboards/dashboardInstance';
import { clearAllAnalysesAction } from '../../../redux/slices/analyses';
import { clearAllLoadingAnalysesAction } from '../../../redux/slices/loadingAnalyses';

const useResetDashboardInstanceEffect = () => {
  const dispatch = useAppDispatch();

  return useEffect(() => {
    return () => {
      batch(() => {
        // Clear instance
        dispatch(dashboardInstanceReset());
        // Clear reports
        dispatch(clearAllAnalysesAction());
        dispatch(clearAllLoadingAnalysesAction());
      });
    };
  }, [dispatch]);
};

export default useResetDashboardInstanceEffect;
